const MS_PER_DAY = 86_400_000;
/**
 * Rental days between two instants. A rental is charged per started day, so
 * 25 hours is 2 days — this deliberately rounds up, and never returns 0.
 */
export function rentalDays(pickupAt, dropoffAt) {
    const start = new Date(pickupAt).getTime();
    const end = new Date(dropoffAt).getTime();
    const days = Math.ceil((end - start) / MS_PER_DAY);
    return Math.max(1, days);
}
/** Do two half-open intervals `[aStart, aEnd)` and `[bStart, bEnd)` overlap? */
export function rangesOverlap(aStart, aEnd, bStart, bEnd) {
    return new Date(aStart) < new Date(bEnd) && new Date(bStart) < new Date(aEnd);
}
export function addDays(date, days) {
    return new Date(new Date(date).getTime() + days * MS_PER_DAY);
}
/** `2026-09-19 14:30` in the user's locale — used in WhatsApp replies and admin. */
export function formatDateTime(value, locale = 'en-GH') {
    return new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(new Date(value));
}
export function isFuture(value) {
    return new Date(value).getTime() > Date.now();
}
